<template>
  <header class="p-3 bg-primary text-white">
    <div class="float-end">
      <div class="dropdown zoom-mt-6 ms-3">
        <button
          class="btn btn-dark dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-globe"></i>
          {{ this.$store.getters.getWordLocale("txt_dili_degistir") }}
        </button>
        <ul class="dropdown-menu lang-ul" style="min-width: 100%; !important;">
          <li
            class="lang-li"
            style="cursor: pointer"
            v-for="(language, index) in this.$store.state.domainLanguages"
            :key="index"
            v-on:click="changeLanguage(language.LangCode)"
          >
            <span
              v-if="this.$store.state.langCodeX != language.LangCode"
              v-bind:class="{
                'd-flex': true,
                'selected-lang':
                  this.$store.state.langCodeX == language.LangCode,
              }"
            >
              <country-flag
                :country="
                  language.LangCode == 'en'
                    ? 'gb'
                    : language.LangCode == 'ar'
                    ? 'sa'
                    : language.LangCode
                "
                size="normal"
              />
              <span style="margin-top: 8px">{{
                language.LangCode.toUpperCase()
              }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="container">
      <div
        class="
          d-flex
          flex-wrap
          align-items-center
          justify-content-center justify-content-lg-start
        "
      >
        <a
          :href="'/' + this.$store.state.langCodeX"
          class="
            d-flex
            align-items-center
            mb-2 mb-lg-0
            text-white text-decoration-none
          "
        >
          <img :src="this.$store.state.systemLogoX" alt="" />
        </a>

        <ul
          class="
            ms-3
            nav
            col-12 col-lg-auto
            me-lg-auto
            mb-2
            justify-content-center
            mb-md-0
          "
        >
          <li>
            <span class="nav-link px-2 text-secondary">
              <router-link :to="'/' + this.$store.state.langCodeX">{{
                this.$store.getters.getWordLocale("txt_anasayfa")
              }}</router-link>
            </span>
          </li>

          <li v-for="(item, index) in headerItemsToShow" :key="index">
            <span class="nav-link px-2 text-secondary">
              <router-link :to="item.link">{{
                this.$store.getters.getWordLocale(item.name.toUpperCase())
              }}</router-link>
            </span>
          </li>

          <li>
            <div>
              <input
                v-model="this.$store.state.searchInputValueX"
                v-on:change="searchEngine()"
                class="form-control search-input w-100 ms-4"
                :placeholder="this.$store.getters.getWordLocale(placeHolder)"
              />
            </div>
          </li>
        </ul>

        <div
          v-show="
            this.$store.state.isMountedDoneX && !this.$store.state.isLoginPageX
          "
        >
          <div v-if="!this.$store.state.userLoggedInX" class="text-end">
            <p class="mb-0">
              <!-- <router-link
                class="btn btn-outline-light me-2"
                :to="'/' + this.$store.state.langCodeX + '/login'"
                ><i class="fas fa-door-open"></i>
                {{ this.$store.getters.getWordLocale("txt_giris_yap") }}
              </router-link> -->
              <a
                class="btn btn-outline-light me-2"
                :href="
                  this.$store.state.loginUrlX +
                  '?apilogin=true&returnUrl=' +
                  this.$store.state.currentUrlX
                "
                ><i class="fas fa-door-open"></i>
                {{ this.$store.getters.getWordLocale("txt_giris_yap") }}
              </a>
              <span class="ms-2 me-2">{{
                this.$store.getters.getWordLocale("txt_veya")
              }}</span>
              <a
                class="btn btn-danger"
                :href="this.$store.state.signUpUrlX"
                target="_blank"
                ><i class="fas fa-user-plus"></i>
                {{ this.$store.getters.getWordLocale("txt_uye_ol") }}</a
              >
            </p>
          </div>
          <div class="d-flex" v-else>
            <b class="mt-2 me-1">{{
              this.$store.getters.getWordLocale("txt_siteye_hos_geldiniz")
            }}</b>
            <div class="dropdown">
              <button
                class="btn me-2 btn-light dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa fa-user-circle"></i>
                {{ this.$store.state.userNameX }}
              </button>
              <span v-show="loggingOut">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" :href="this.$store.state.myPageUrlX">
                    <i class="fa fa-user"></i> |
                    {{
                      this.$store.getters.getWordLocale("txt_benim_sayfam")
                    }}</a
                  >
                </li>

                <li>
                  <a
                    v-on:click="logout"
                    class="dropdown-item"
                    href="javascript:;"
                  >
                    <i class="fa fa-duotone fa-lock"></i> |
                    {{ this.$store.getters.getWordLocale("txt_cikis_yap") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import CountryFlag from "vue-country-flag-next";
import helper from "./helper";

export default {
  components: {
    CountryFlag,
  },
  props: ["placeHolder"],
  data() {
    return {
      loggingOut: false,
      headerItemsToShow: [],
    };
  },
  methods: {
    async logout() {
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");
      this.loggingOut = true;
      await fetch(`${this.$store.state.apiUrlX}/api/v2/Account/logout`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({}),
      })
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.loggingOut = false;
      if (result.resultText == "Success") {
        this.$store.state.userLoggedInX = false;
        helper.setCookie("fn_access_token", "");
        window.location.href = `http://auth.${this.$store.state.parentDomainX}/en/account/logout?returnUrl=${this.$store.state.currentUrlX}`;
      } else {
        this.$store.state.userLoggedInX = false;
        helper.setCookie("fn_access_token", "");
        window.location.href = `/${this.$store.state.langCodeX}`;
      }
    },
    searchEngine() {
      var host = window.location.href;
      this.$store.state.isSearchChangedX = true;
      if (host.indexOf("/lead/") !== -1) {
        this.$router.push("/leads");
      } else if (
        host.indexOf("/companies") == -1 &&
        host.indexOf("/leads") == -1 &&
        host.indexOf("/products") == -1
      ) {
        if (
          this.$store.state.headerItemsX.filter(
            (q) => parseInt(q.id) == 1
          ).length > 0
        ) {
          this.$router.push(`/${this.$store.state.langCodeX}/companies`);
        } else if (
          this.$store.state.headerItemsX.filter(
            (q) => parseInt(q.id) == 2
          ).length > 0
        ) {
          this.$router.push(`/${this.$store.state.langCodeX}/leads`);
        } else {
          this.$router.push(`/${this.$store.state.langCodeX}/products`);
        }
      }
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
  },
  mounted() {
    this.$store.state.headerItemsX.forEach((element) => {
      var name =
        element.name == "Firma"
          ? "Firmalar"
          : element.name == "Talep"
          ? "Talepler"
          : "Ürünler";
      var link =
        element.name == "Firma"
          ? `/${this.$store.state.langCodeX}/companies`
          : element.name == "Talep"
          ? `/${this.$store.state.langCodeX}/leads`
          : `/${this.$store.state.langCodeX}/products`;

      this.headerItemsToShow.push({ name: name, link: link });
    });
  },
};
</script>

<style scoped>
header a {
  text-decoration: none;
  color: white;
}
header img {
  /* background: #fff; */
  padding: 2px;
  padding-right: 10px;
  padding-left: 10px;
  max-width: 160px;
  /* border-radius: 40px; */
}

.active {
  background-color: #f7f7f7;
  border-radius: 5px;
  padding: 7px;
  font-weight: 800;
  color: #0b5ed7;
}

.search-input {
  width: 420px !important;
}

.selected-lang {
  box-shadow: 0px 1px 20px 0px #d9e8ff;
  border-radius: 8px;
}

.dropdown-item {
  color: #0b5ed7 !important;
}

.zoom-mt-6 {
  zoom: 80%;
  margin-top: 6px;
}

.lang-ul {
  left: 100% !important;
}

.lang-li:hover {
  box-shadow: 0px 1px 20px 0px #c8c9ca;
  border-radius: 8px;
}
</style>